import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import Mensalon  from "../../Assets/Projects/Mensalon.png";
import webmining from "../../Assets/Projects/webmining.png";
import AgeCalculator from "../../Assets/Projects/AgeCalculator.png";
import courses from "../../Assets/Projects/courses.png";
import USER from "../../Assets/Projects/USER.png";
import WeatherImg from "../../Assets/Projects/WeatherImg.png";
import portfolio from "../../Assets/Projects/portfolio.png";
import Voicesynthesis from "../../Assets/Projects/Voicesynthesis.png";
import MUI from "../../Assets/Projects/MUI.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Project <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Mensalon}
              isBlog={false}
              title="Men Salon Management System"
              description={
                <ul>
                  <li>Web-based application for data management.</li>
                  <li>Focus on administrative and inventory aspects.</li>
                  <li>Designed for salon management systems.</li>
                </ul>
              }
              ghLink="https://github.com/Shiva-from-Hanchihalli/MEN-SALON-MANAGEMENT-SYSTEM"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={webmining}
              isBlog={false}
              title="Web Mining For Suspecious Keywords"
              description={
                <ul>
                  <li>Detects suspicious keywords on web pages.</li>
                  <li>Categorizes keywords (e.g., religious, adult, terrorism).</li>
                  <li>Displays warning if suspicious activity exceeds threshold.</li>
                </ul>
              }
              ghLink="https://github.com/Shiva-from-Hanchihalli/web-mining-for-suspecious-keywordss"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={courses}
              isBlog={false}
              title="Course App "
              description={
                <ul>
                  <li>Developed course platform with Firebase authentication.</li>
                  <li>Features user registration, login, Google sign-in, and password reset.</li>
                  <li>Used React Context API for user state management.</li>
                </ul>
              }
              ghLink="https://github.com/Shiva-from-Hanchihalli/Coursesapp-Typescript"
             demoLink="https://shiva-73xt.onrender.com/"
            />
          </Col>
          

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={WeatherImg}
              isBlog={false}
              title="Weather App"
              description={
                <ul>
                  <li>React weather app fetching real-time data.</li>
                  <li>Displays temperature, humidity, wind speed, and cloud info.</li>
                  <li>Dynamically updates interface based on city input.</li>
                </ul>
              }
              ghLink="https://github.com/Shiva-from-Hanchihalli/React-WeatherAPP"
              demoLink="https://shivuweatherapp.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Voicesynthesis}
              isBlog={false}
              title="Voice Synthesis App"
              description={
                <ul>
                  <li>Voice synthesis app integrated with an API.</li>
                  <li>Responds to specific voice commands to retrieve information.</li>
                  <li>Hands-free interaction for efficient data retrieval.</li>
                </ul>
              }
              ghLink="https://github.com/Shiva-from-Hanchihalli/React-router-and-Voice-Synthesis"
              // demoLink="https://www.youtube.com/watch?v=dQw4w9WgXcQ&ab_channel=RickAstley"
            />
          </Col>

        
     
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={portfolio}
              isBlog={false}
              title="Developer Portfolio Website"
              description={
                <ul>
                  <li>Fully customizable and dynamic React portfolio.</li>
                  <li>Responsive design for desktops and laptops.</li>
                  <li>Showcases projects with interactive flair and animations.</li>
                </ul>
              }
              ghLink="https://github.com/Shiva-from-Hanchihalli/Portfolio_Website"
              demoLink="https://shivanewweb.netlify.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={AgeCalculator}
              isBlog={false}
              title="Age Calculator"
              description={
                <ul>
                  <li>Age calculator based on date inputs.</li>
                  <li>Displays age in years, months, weeks, and days.</li>
                  <li>Also shows the day of birth.</li>
                </ul>
              }
              ghLink="https://github.com/Shiva-from-Hanchihalli/AGE-CAlCULATOR"
              // demoLink="https://editor.soumya-jit.tech/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={MUI}
              isBlog={false}
              title="React App Display the data In MUI cards"
              description={
                <ul>
                 <li>A simple react App lets you enter the data and display in MUI Cards
Uses Redux for State Management.</li>
<li>This app lets you add, delete or update tasks.</li>
                </ul>
              }
              ghLink="https://github.com/Shiva-from-Hanchihalli/Data-displaying-in-MUI-Cards"
              demoLink="https://shivakumarredux.netlify.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={USER}
              isBlog={false}
              title="UserSlice"
              description={
                <ul>
                <li>The app lets you add users from an API-driven dropdown to a table and automatically re-adds removed users to the dropdown.</li>
               <li> It uses Redux for state management and React fundamentals..</li>
                </ul>
              }
              ghLink="https://github.com/Shiva-from-Hanchihalli/UserSlice/tree/main/UserSlice"
              demoLink="https://shivahm.netlify.app/"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
